import { readStates, states } from '@/constants/lifecycle';
import findResult, { assignProps } from '@/utils/resultsHelper';
import { fieldLengths } from '@/constants/fields';
import formFieldTypes from '@/forms/constants';
import { findFormFieldByName } from '@/forms/state/state';
import { workspaceForms, workspaceReferenceFieldCode } from '../constants';

export const workspaceFormSections = () => ({ sections: { workspace: { label: '', fields: [] } } });

export const openWorkspaceForm = ({ code }, readStatus = states.PENDING) => ({
  code,
  readStatus,
  readErrors: [],
  ...workspaceFormSections(),
});

export const findWorkspaceLocations = ({ locations }, { category }) => locations[category];

export const findWorkspaceForm = ({ forms }, { category, code }) => findResult(forms, category, code);

export const activeRequestReceiptState = (open = false, name = '', text = '') => ({
  open, name, text,
});

export const workspaceReferenceField = (intl) => ({
  label: intl.formatMessage({ id: 'workspace.reference.label' }),
  name: workspaceReferenceFieldCode,
  type: formFieldTypes.STRING.type,
  placeholder: intl.formatMessage({ id: 'workspace.reference.placeholder' }),
  validation: { maximum: fieldLengths.small, required: true },
});

export const addWorkspaceRequestFieldsToSections = ({ sections }, intl) => {
  const [name] = Object.keys(sections);
  if (!findFormFieldByName({ sections }, workspaceReferenceFieldCode)) {
    sections[name].fields.unshift(workspaceReferenceField(intl));
  }
};

export const showWorkspaceFormState = (draft, { category, code, result }) => {
  const item = findWorkspaceForm(draft, { category, code });
  assignProps(item, {
    ...result,
    code,
    readStatus: states.SUCCESS,
    readErrors: [],
  });
};

const initialState = {
  activeRequestReceipt: activeRequestReceiptState(),
  locations: {
    lookups: {
      results: [],
      ...readStates,
    },
  },
  forms: {
    open: {
      results: [openWorkspaceForm({ code: workspaceForms.REQUEST }, states.NONE)],
    },
    health: {
      [workspaceForms.REQUEST]: { ...readStates },
    },
  },
};

export default initialState;
